import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-1 text-lg font-semibold flex items-center" }
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "inline-block transition-transform group-hover:translate-x-1 motion-reduce:transform-none" }
const _hoisted_4 = { class: "m-0 max-w-[50ch] text-sm opacity-50" }

import router from "@/router";
import { ArrowRightIcon } from '@heroicons/vue/20/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkBox',
  props: {
    title: {},
    description: {},
    route: {},
    routeParams: {},
    url: {}
  },
  setup(__props: any) {

const props = __props

function click() {
  if (props.route) {
    router.push({
      name: props.route,
      params: props.routeParams || {},
    });
  } else if (props.url) {
    window.location.href = props.url;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: click,
    class: "group link"
  }, [
    _createElementVNode("h2", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(ArrowRightIcon), { class: "w-5 h-5" })
      ])
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1)
  ]))
}
}

})